var BxfButtonTypeEnum;
(function (BxfButtonTypeEnum) {
    // new button type enums:
    BxfButtonTypeEnum["PRIMARY"] = "primary";
    BxfButtonTypeEnum["SECONDARY"] = "secondary";
    BxfButtonTypeEnum["TERTIARY"] = "tertiary";
    BxfButtonTypeEnum["TERTIARY_SUBTLE"] = "tertiary-subtle";
    BxfButtonTypeEnum["DESTRUCTIVE_PRIMARY"] = "destructive-primary";
    BxfButtonTypeEnum["DESTRUCTIVE_SECONDARY"] = "destructive-secondary";
    BxfButtonTypeEnum["DESTRUCTIVE_TERTIARY"] = "destructive-tertiary";
    BxfButtonTypeEnum["AFFIRMATIVE_PRIMARY"] = "affirmative-primary";
    BxfButtonTypeEnum["AFFIRMATIVE_SECONDARY"] = "affirmative-secondary";
    BxfButtonTypeEnum["AFFIRMATIVE_TERTIARY"] = "affirmative-tertiary";
    BxfButtonTypeEnum["BUY_PRIMARY"] = "buy-primary";
    BxfButtonTypeEnum["BUY_SECONDARY"] = "buy-secondary";
    BxfButtonTypeEnum["SELL_PRIMARY"] = "sell-primary";
    BxfButtonTypeEnum["SELL_SECONDARY"] = "sell-secondary";
    BxfButtonTypeEnum["CARD"] = "card";
})(BxfButtonTypeEnum || (BxfButtonTypeEnum = {}));

export { BxfButtonTypeEnum as B };
